var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((12),function(item,i){return _c('v-col',{key:i,style:({ opacity: 1 - (i * 0.08) }),attrs:{"xl":"1","lg":"1","md":"2","sm":"3","cols":"4"}},[_c('v-card',{attrs:{"outlined":""}},[_c('v-skeleton-loader',{attrs:{"type":"article"}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }